import Vue from 'vue'
import App from './App.vue'
import axios from '@util/axios';
import router from '@router/router';
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-launch-app'];

// Vue plugin
import Pin from 'vue-pin';
Vue.use(Pin)

import gallery from "img-vuer";
Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
  sliderBackgroundColor: "rgba(0,0,0,0.6)",
  sliderZIndex: 1001,
});

import VueLazyComponent from '@xunlei/vue-lazy-component'
Vue.use(VueLazyComponent)

// router.beforeEach((to,from,next) =>{
//   if(to.meta.title){
//     document.title = to.meta.title
//   }
// })

new Vue({
  el: '#app',
  axios,
  router,
  render: h => h(App),
}).$mount('#app')
